<template lang="pug">
  ul.menu-list
    li(
      :class="{active: article.active}"
      v-for="(article,index) in articles"
      @click="goTo(index)"
    ).item.menu-item  {{article.shortText || article.text}}
</template>

<script>
export default {
  props: {
    articles: {
      default: () => [],
      type: Array,
    },
  },
  methods: {
    goTo(index) {
      this.$emit('menu-item-click', index);
    },
  },
};
</script>

<style lang="stylus" scoped>
  @import url('../../static/fonts/rift/stylesheet')
  @import url('../../static/fonts/futura/stylesheet')

  *
    font-family 'Rift Soft'

  .menu-list
    position absolute
    padding 0
    margin 0
    display flex
    left var(--horizontal-menu-left)

  .item
    list-style none
    font-family 'Futura Lt BT'
    text-transform uppercase
    vertical-align middle
    color rgba(255, 255, 255, .5)
    cursor pointer

  .menu-item
    font-size var(--horizontal-menu-item-font-size)
    margin-right var(--horizontal-menu-item-margin-right)

    &.active
      color white

  @media screen and (max-width: 1024px)
    .menu-list
      position absolute
      text-align right
      top 50%
      right 0
      transform translateY(-50%)
      margin-right var(--menu-margin-right)
      display block

    .menu-item
      font-size var(--menu-item-font-size)
      line-height var(--menu-item-line-height)

      &:after
        display inline-block
        border var(--menu-item-check-box-border) solid rgba(255, 255, 255, .5)
        width var(--menu-item-check-box-width)
        height var(--menu-item-check-box-height)
        content ''
        border-radius var(--menu-item-check-box-border-radius)
        margin-left var(--menu-item-check-box-left)
        margin-bottom var(--menu-item-check-box-bottom)

      &.active
        &:after
          border var(--menu-item-check-box-border) solid rgba(255, 255, 255, 1)
          background-color white

  @media screen and (max-width: 700px)
    .menu-list
      display none

  @media screen and (max-width: 825px) and (orientation: landscape)
    .menu-list
      display none
</style>



// WEBPACK FOOTER //
// src/components/ExploreMenu.vue